import React, { useEffect, useRef, useState } from 'react'
import {
  teamsApi,
  useGetTeamsQuery,
} from "../../features/teams/teamsApi";
import {useDeleteProjectMutation} from "../../features/projects/projectsApi";
import { useSelector } from "react-redux";
import { useDrag ,useDrop } from "react-dnd";
import {useUpdateProjectMutation} from "../../features/projects/projectsApi";


const Item = ({item, backlog, playerType, index }) => {
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};
  const { data, isLoading, isError, error } = useGetTeamsQuery(loggedInUser.id) || {};
  const [deleteProject] = useDeleteProjectMutation();
  const [clickedOutside, setClickedOutside] = useState(false);
  const [showOptions,setShowOptions]=useState(false);
  const [updateProject ] = useUpdateProjectMutation();
  const { search } = useSelector((state) => state.project);
  const myRef = useRef();
  
  const [{ isDragging }, dragRef] = useDrag({
    type: playerType,
    item: () => ({ ...item, index }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const findTeam = (item)=>{
    let obj = data.find((value)=>value.id==item);
    return obj
  }


  const handleClickOutside = e => {
    if (e.target.textContent!='Delete') {
        setClickedOutside(true);
        setShowOptions(false);
    }
  };

  const handleClickInside = () =>{
    setClickedOutside(false);
    setShowOptions(true);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  const handleDelete = ()=>{
    deleteProject(item.id)
  }
  return (
    <div
      className={`relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100 ${search !=='' && item.title.toLowerCase().includes(search.toLowerCase()) ? 'border-2 border-rose-500':'' } `}
      draggable="true"
      ref={dragRef}
    >
      {showOptions && backlog && 
        <div onClick={handleDelete} className="inline-block absolute right-6 -top-5 z-100 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm  transition-opacity  tooltip dark:bg-pink-700">
                Delete
        </div>
      }
      {backlog && 
      <button className="absolute top-0 right-0 flex items-center justify-center hidden w-5 h-5 mt-3 mr-2 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 group-hover:flex"
              onClick={handleClickInside}
              ref={myRef}
      >
        <svg
          className="w-4 h-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
        </svg>
      </button>
      }
      <span className={`flex items-center h-6 px-3 text-xs font-semibold text-white-500 ${data && data.length>0 && findTeam(item.teamId).color} rounded-full`}>
        {data && data.length>0 && findTeam(item.teamId).name}
      </span>
      <h4 className="mt-3 text-sm font-medium">
        {item.title}
      </h4>
      <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
        <div className="flex items-center">
          <svg
            className="w-4 h-4 text-gray-300 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
              clipRule="evenodd"
            />
          </svg>
          <span className="ml-1 leading-none">{item.created}</span>
        </div>

        <img
          className="w-6 h-6 ml-auto rounded-full"
          src={item?.creatorImg}
        />
      </div>
    </div>
  );
}

export default Item;